export const MESSAGE_TEMPLATE_SEND_WINDOW_ERR_MINUTES = 15;
export const SMS_COMPLIANCE_FOOTER =
  'Reply STOP/START to block/unblock all msg from this number. Msg&Data Rates May Apply.';
